export default __webpack_public_path__ + "static/media/visa.22144b4d.png";